<template>
	<Panel :title="'Actividad'" icon="rss" class="actividad-quinielazo is-relative">
		<div class="contenedor">
			<ActividadRow v-for="noticia in feed" :key="noticia.id+noticia.tipo" :text="noticiaTexto(noticia)" :icon="noticiaIcon(noticia)" :created="noticia.created_at" :link="genLink(noticia)"  />
			
		</div>
		
	</Panel>
</template>

<script>
	import Panel from '@/components/Panel'
	import ActividadRow from '@/components/ActividadRow'
	import { mapState } from 'vuex'

	export default {
		components: { Panel, ActividadRow },
		name: 'Actividad',

		data() {
			return {

			};
		},
		methods:{
			noticiaTexto(noticia){
				if (noticia.texto != undefined) {
					return noticia.texto
				}else{
					let text
					switch(noticia.tipo){
						case 'unidoaquiniela':
							text = 'El usuario ' + noticia.usuario + ' se unio a la quiniela <strong>' + noticia.nombre + '</strong>'
						break;
						case 'quinielacreada':
							text = 'El usuario ' + noticia.usuario + ' creo la quiniela <strong>' + noticia.nombre + '</strong>'
						break;
						case "quinielaganada":
							text = 'El usuario ' + noticia.usuario + ' ganó la quiniela <strong>' + noticia.nombre + '</strong>'
						break;
					}

					return text
				}
			},
			noticiaIcon(noticia){
				let icono
				switch(noticia.tipo){
					case 'quinielapublica':
						icono = 'globe-americas'
					break;
					case 'partidoagregado':
					case 'partidoterminado':
						icono = 'futbol'
					break;
					case 'unidoaquiniela':
					case 'quinielacreada':
						icono ='check-square'
					break;
					case 'usuariounido':
						icono ='user'
					break;
					case 'quinielaganada':
						icono = 'trophy'
					break;
				}

				return icono
			},
			genLink(noticia){
				let link
				switch(noticia.tipo){
					case 'quinielapublica':
					case 'unidoaquiniela':
					case 'quinielacreada':
					case 'quinielaganada':
						link = { 
							btnText: 'Abrir', 
							route:{ 
								name: 'ver-quiniela', 
								params:{ id: noticia.id} 
							}
						}
					break;
					case 'usuariounido':
						link = { 
							btnText: 'Ver perfil', 
							route:{ 
								name: 'perfil', 
								params:{ id: noticia.id} 
							}
						}
					break;
				}

				return link
			}
		},
		created(){
			this.$store.dispatch('jugadores/getFeed')
		},
		computed: {
			feedlimitado(){
				return this.feed.slice(0,10)
			},
			...mapState('jugadores',['feed'])
		}
	};
</script>

<style lang="css" scoped>
.actividad-quinielazo{
	font-size: 0.8em;
	
    flex-basis: 100px;
    flex-grow: 1;
	overflow: hidden;
}
.contenedor{
	max-height: 90%;
	overflow-y: auto;
	display: block;
}
</style>
